module.exports = __webpack_public_path__ + "img/Silver.38dcd6bd.svg";